var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-with-checkbox",style:(`padding-left: ${_vm.identation * 1}rem; width: 100%;`),on:{"click":_vm.handleClick}},[_c('IndeterminateCheckbox',{attrs:{"indeterminate":_vm.indeterminate,"checked":_vm.checked}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }